import { createRouter, createWebHashHistory } from "vue-router";
import Home from "../views/Home.vue";

const routes = [
    {
        path: '/',
        redirect: '/dashboard'
    },
    {
        path: "/",
        name: "Home",
        component: Home,
        children: [
            {
                path: "/dashboard",
                name: "dashboard",
                meta: {
                    title: '系统首页'
                },
                component: () => import(
                    /* webpackChunkName: "dashboard" */
                    "../views/Dashboard.vue")
            }, {
                path: "/table",
                name: "basetable",
                meta: {
                    title: '表格'
                },
                component: () => import(
                    /* webpackChunkName: "table" */
                    "../views/BaseTable.vue")
            }, {
                path: "/charts",
                name: "basecharts",
                meta: {
                    title: '图表'
                },
                component: () => import(
                    /* webpackChunkName: "charts" */
                    "../views/BaseCharts.vue")
            }, {
                path: "/form",
                name: "baseform",
                meta: {
                    title: '表单'
                },
                component: () => import(
                    /* webpackChunkName: "form" */
                    "../views/BaseForm.vue")
            }, {
                path: "/tabs",
                name: "tabs",
                meta: {
                    title: 'tab标签'
                },
                component: () => import(
                    /* webpackChunkName: "tabs" */
                    "../views/Tabs.vue")
            }, {
                path: "/donate",
                name: "donate",
                meta: {
                    title: '鼓励作者'
                },
                component: () => import(
                    /* webpackChunkName: "donate" */
                    "../views/Donate.vue")
            }, {
                path: "/permission",
                name: "permission",
                meta: {
                    title: '权限管理',
                    permission: true
                },
                component: () => import(
                    /* webpackChunkName: "permission" */
                    "../views/Permission.vue")
            }, {
                path: "/i18n",
                name: "i18n",
                meta: {
                    title: '国际化语言'
                },
                component: () => import(
                    /* webpackChunkName: "i18n" */
                    "../views/I18n.vue")
            }, {
                path: "/upload",
                name: "upload",
                meta: {
                    title: '上传插件'
                },
                component: () => import(
                    /* webpackChunkName: "upload" */
                    "../views/Upload.vue")
            }, {
                path: "/icon",
                name: "icon",
                meta: {
                    title: '自定义图标'
                },
                component: () => import(
                    /* webpackChunkName: "icon" */
                    "../views/Icon.vue")
            }, {
                path: '/404',
                name: '404',
                meta: {
                    title: '找不到页面'
                },
                component: () => import(/* webpackChunkName: "404" */
                    '../views/404.vue')
            }, {
                path: '/403',
                name: '403',
                meta: {
                    title: '没有权限'
                },
                component: () => import(/* webpackChunkName: "403" */
                    '../views/403.vue')
            },
            {
                path: '/product_list',
                name: '产品列表',
                meta: {
                    title: '产品列表'
                },
                component: () => import(/* webpackChunkName: "403" */
                    '@/views/product/list.vue')
            },
            {
                path: '/product_catList',
                name: '产品分类列表',
                meta: {
                    title: '产品分类列表'
                },
                component: () => import(/* webpackChunkName: "403" */
                    '@/views/product/catList.vue')
            },
            {
                path: '/role_list',
                name: '角色列表',
                meta: {
                    title: '角色列表'
                },
                component: () => import(/* webpackChunkName: "403" */
                    '@/views/role/list.vue')
            },
            {
                path: '/user_list',
                name: '账号管理',
                meta: {
                    title: '账号列表'
                },
                component: () => import(/* webpackChunkName: "403" */
                    '@/views/user/list.vue')
            },
            {
                path: '/log_list',
                name: '日志',
                meta: {
                    title: '日志'
                },
                component: () => import(/* webpackChunkName: "403" */
                    '@/views/log/list.vue')
            },
            {
                path: '/dashboard',
                name: '首页',
                meta: {
                    title: '首页'
                },
                component: () => import(/* webpackChunkName: "403" */
                    '@/views/Dashboard.vue')
            }
        ]
    }, {
        path: "/login",
        name: "Login",
        meta: {
            title: '登录'
        },
        component: () => import(
            /* webpackChunkName: "login" */
            "../views/Login.vue")
    }
];

const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    routes
});

router.beforeEach((to, from, next) => {
    document.title = `${to.meta.title} | 后台表格系统`;
    if (to.path == '/login') {
        next();

    } else if (to.path !== '/login') {
        if (window.localStorage.getItem("token")) {
            next();
        }
        else {
            next('/login');
        }

        // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
    }
});

export default router;